module.exports = __webpack_public_path__ + "static/media/phone.7be26e39.png";